import http from "../http/http-config";
import { GenericModulePlan } from "../models/genericModulePlan";

export default new class GenericModulePlanService {
    getGenericModulePlans(productId): Promise<GenericModulePlan[]> {
        return http.get<GenericModulePlan[]>("GetGenericModulePlan", {
            params: {
                productId,
            }
        }).then(response => response.data)
    }
}